import { FC, memo, useCallback } from 'react'

import { FormInputProps } from 'brief-form'
import { IconName, IconSize } from 'ui/components/Icon'

import { s } from './styles'

type Opts = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  validator?: (value: string | number | null) => string | undefined
  icon?: IconName
  iconSize?: IconSize
  iconColor?: string
  dataQa?: string
  'data-lpignore'?: boolean
}

type AuthProps = FormInputProps<string | number, Opts>

export const AuthInput: FC<AuthProps> = memo((props) => {
  const {
    onChange,
    value,
    required,
    error,
    validator,
    icon,
    iconSize = icon ? IconSize.S : 0,
    iconColor,
    dataQa,
    ...rest
  } = props

  const getError = useCallback(
    (value: string | number | null) => {
      if (required && (!value || !value.toString().trim())) {
        return 'Required'
      }
      if (validator) {
        return validator(value)
      }
      return undefined
    },
    [validator, required]
  )

  const onTextChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value: number | string | null = event.target.value
      if (onChange) {
        onChange(value || '', getError(value))
      }
    },
    [onChange, getError]
  )

  return (
    <s.Container>
      {icon && <s.WrappedIcon name={icon} fill={iconColor} size={iconSize} />}
      <s.SCInput
        {...rest}
        data-qa={dataQa}
        required={required}
        error={!!error}
        onChange={onTextChange}
        value={value || ''}
        iconSize={iconSize}
      />
    </s.Container>
  )
})
